import React from 'react';
import { OverviewLayout } from '../../components/DetailLayout';
import OverviewLayoutSection from '../../components/OverviewLayout/OverviewLayoutSection';
import Typography from '../../components/Typography';
import useApi from '../../hooks/api.hooks';
import { translate } from '../../i18n';
import NewsletterEmail from './NewsletterEmail';
import NewsletterFilter from './NewsletterFilter';
import NewsletterOverview from './NewsletterOverview';

const Newsletters: React.FC = () => {
  const { data: categories } = useApi('/newsletters/categories');

  return (
    <OverviewLayout title="newsletters.title" wide>
      <OverviewLayoutSection title={translate('newsletters.email.title')}>
        <div className="row">
          <div className="col-xs-12 col-lg-6 col-xl-4">
            <Typography classNames="u-margin-bottom-xs">
              {translate('newsletters.email.description')}
            </Typography>
            <NewsletterEmail />
          </div>
        </div>
      </OverviewLayoutSection>

      <OverviewLayoutSection title={translate('newsletters.overview.title')}>
        <NewsletterFilter categories={categories} />
        <NewsletterOverview />
      </OverviewLayoutSection>
    </OverviewLayout>
  );
};

export default Newsletters;
